import axios from 'axios'
import store from '@/store/index.js'

// 创建axios
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_IM_API, // url = base url + request url
  timeout: 600000 // request timeout
})
// 添加请求拦截器
service.interceptors.request.use(function(config) {

  let token = store.state.imtoken;
  if (token) {
    config.headers["token"] = token;
  }

  return config;
}, function(error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 添加响应拦截器
service.interceptors.response.use(function(response) {
  // 对响应数据做点什么

  return response;
}, function(error) {
  // 对响应错误做点什么
  var msg = "";
  switch (error.response && error.response.status) {
    case 400:
      msg = error.response.data.msg;
      break;
    case 404:
      msg = "请求地址没有找到（404）"
      break;
    case 401:
      msg = "401错误"
      break;
    default:
      msg = "未知错误"
      break;
  }
  return Promise.reject({
    error: error,
    msg: msg,
    status: error?.response?.status
  });
});
export default service;